import React from 'react';
import { ArrowRight, Phone, MapPin, Clock } from 'lucide-react';
import './HeroSection.css';
import AddressLink from './AddressLink';
import heroImage from '../assets/ob-homepage2.jpeg';

const HeroSection = () => {
  const scrollToContact = () => {
    const element = document.getElementById('kontakt');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToServices = () => {
    const element = document.getElementById('leistungen');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero-section hero-animate">
      <div className="hero-background"></div>
      <div className="container hero-container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              {[
                'Recover with purpose.',
                'Return with confidence.',
                'Prevent with knowledge.',
              ].map((line, index) => (
                <span
                  key={line}
                  className="hero-title-line"
                  style={{ '--hero-delay': `${120 + index * 90}ms` }}
                >
                  {line}
                </span>
              ))}
            </h1>
            <p className="hero-subtitle" style={{ '--hero-delay': '400ms' }}>
              Individuelle Sportphysiotherapie in Hornstein – für Menschen, die aktiv bleiben,
              zurück in den Sport wollen oder Beschwerden langfristig vorbeugen möchten.
            </p>
            <div className="hero-buttons" style={{ '--hero-delay': '500ms' }}>
              <button className="btn-primary" onClick={scrollToContact}>
                Termin vereinbaren
                <ArrowRight size={20} style={{ marginLeft: '8px' }} />
              </button>
              <button className="btn-secondary" onClick={scrollToServices}>
                Leistungen ansehen
              </button>
            </div>
            <div className="hero-info" style={{ '--hero-delay': '600ms' }}>
              <div className="info-item">
                <MapPin size={18} />
                <AddressLink
                  variant="compact"
                  label="Alte Bandfabrik 1, 7053 Hornstein"
                  className="hero-address-link"
                />
              </div>
              <div className="info-item">
                <Phone size={18} />
                <a href="tel:06641510494">0664 1510494</a>
              </div>
              <div className="info-item">
                <Clock size={18} />
                <span>Samstag 8–20 Uhr</span>
              </div>
            </div>
          </div>
          <div className="hero-image" style={{ '--hero-delay': '280ms' }}>
            <div className="image-placeholder">
              <img
                src={heroImage}
                alt="Sportphysiotherapie Oliver Bauer – Behandlung in der Praxis Hornstein"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
